import React from 'react';

const PrayerIcon: React.FC<{ fill: string }> = ({ fill = '#ffffff' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width="20.8"
    height="20.88"
    viewBox="0 0 20.8 20.88"
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          fill={fill}
          d="M9.49.76c-.01-.33-.33-.57-.65-.5-.74.17-1.37.43-1.66.77-1.65,1.93-1.5,9.46-2.86,10.87-.76.79-3.7.7-4.26,1.82-.04.07-.05.16-.05.25-.04,8.34,3.69,8.1,9.28,4.7.15-.09.26-.26.26-.44.17-5.82.15-11.64-.06-17.45Z"
        />
        <path
          fill={fill}
          d="M20.77,13.99c0-.1-.02-.2-.06-.28-.53-1.14-2.59-.99-3.63-1.68-2.72-1.8-1.72-10.57-4.21-11.79C12.58.1,12.08.02,11.49,0c-.42-.01-.76.34-.75.76.2,5.75.22,11.5.06,17.25,0,.26.12.51.34.65,5.37,3.41,10.08,3.64,9.63-4.67Z"
        />
      </g>
    </g>
  </svg>
);

export default PrayerIcon;
